/**
 * Parses a `YYYY-MM-DD` date-only string into a `Date` anchored at local
 * midnight.
 *
 * `new Date('2026-06-15')` parses the string as UTC midnight, which shifts to
 * the previous day in negative-offset timezones when later formatted in local
 * time (off-by-one). Building the date from its year/month/day parts keeps it on
 * the intended calendar day regardless of the viewer's timezone.
 *
 * @param value - a date-only string in `YYYY-MM-DD` format
 * @returns a `Date` at local midnight of the given calendar day
 */
export const parseDateOnly = (value: string): Date => {
  const [year, month, day] = value.split('-').map(Number) as [
    number,
    number,
    number,
  ];
  return new Date(year, month - 1, day);
};
